// @flow
import { stylesheet } from 'typestyle';
import DynamicBase from './DynamicBase';

import ErrorBoundary from '../ErrorBoundary';

import { ObjectType } from '@types/misc';

type TProps = {
  onShow?: () => void,
  onClose?: () => void,
  style?: ObjectType,
  containerStyle?: ObjectType,
  className?: string,
  minWidth?: number | string,
  maxWidth?: number | string,
  hideCloseButton?: boolean,
  doNotScrollToPopup?: boolean,
  preferSideAttachment?: boolean,
  whiteBackground?: boolean,
  initialContent: {
    Header?: string,
    Content: Node
  }
};

type PopupPropsType = {
  show: boolean,
  onCloseClick: () => void,
  anchorElement?: HTMLElement | null
};

type ContainerPropsType = {
  children: React.Node
};

type ContainerStateType = {
  showPopup: boolean
};

const questionMark = '/images/question_mark_with_circle.svg';
const questionMarkWhiteBackground =
  '/images/question_mark_with_circle_white_background.svg';

const classes = stylesheet({
  labelQuestionMark: {
    display: 'inline-block',
    marginLeft: '6px',
    position: 'relative',
    lineHeight: 0,
    verticalAlign: 'baseline',
    cursor: 'pointer',
    height: 13
  }
});

export default class QuestionMarkPopup extends React.Component<
  TProps,
  ContainerStateType
> {
  questionMarkRef: void | React.ElementRef<'a'>;

  state = {
    showPopup: false
  };

  showPopup = (e: SyntheticMouseEvent<HTMLImageElement>) => {
    e.preventDefault();
    if (!this.state.showPopup) this.setState({ showPopup: true });
  };

  handleKeyPress = (e: SyntheticKeyboardEvent<HTMLImageElement>) => {
    if (e.key == 'Enter') {
      this.setState({ showPopup: !this.state.showPopup });
    }
  };

  handleBlur = () => {
    if (this.state.showPopup) {
      this.setState({ showPopup: false });
    }
  };

  closePopup = () => {
    this.setState({ showPopup: false });
  };

  render () {
    return (
      <ErrorBoundary fallback={false}>
        <span
          className={this.props.className}
          style={this.props.containerStyle || {}}>
          <img
            src={
              this.props.whiteBackground ? (
                questionMarkWhiteBackground
              ) : (
                questionMark
              )
            }
            onClick={this.showPopup}
            onKeyPress={this.handleKeyPress}
            // onBlur={this.handleBlur}
            className={classes.labelQuestionMark}
            style={this.props.style}
            role="button"
            tabIndex={0}
            ref={(ref) => {
              this.questionMarkRef = ref || undefined;
            }}
          />

          <DynamicBase
            {...this.props}
            show={this.state.showPopup}
            onCloseClick={this.closePopup}
            anchorElement={this.questionMarkRef}
          />
        </span>
      </ErrorBoundary>
    );
  }
}
